import Index from ".";

export const interfaceReprocessRoutes = [
  {
    path: "/interface-reprocess",
    element: <Index />,
  },
];
